import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/spring-cleanup-highland-ut")({
  beforeLoad: () => {
    throw redirect({
      href: "/services/spring-cleanup",
      statusCode: 301,
    });
  },
});
